<div class="step-content">
  <app-input-select-button [formData]="currentFormatConfig"  />
</div>
